<app-header></app-header>
<gcm-notifications></gcm-notifications>
<app-sidenav class="lg:flex" [showMobileSideNav]="showSideNav"
(openSideNav)="openSideNav()"></app-sidenav>